import React from 'react';

export default {
  svg: (
    <g id="Finding-Care" fill="none" fillRule="evenodd">
      <g id="Triage-Whats-Wrong-03" transform="translate(-44 -446)" fill="#231F20">
        <path
          d="M46.298,451.599708 L45.636,451.598699 L45.636,451.599708 L45.353,451.599708 C45.572,450.796434
           46.303,450.20407 47.168,450.20407 L56.832,450.20407 C57.697,450.20407 58.428,450.796434 58.648,451.599708
            L46.298,451.599708 Z M56.328,461.8798 C56.292,462.341986 55.807,462.703257 55.222,462.703257
             L55.22,462.703257 L48.81,462.696193 C48.222,462.695184 47.734,462.330885 47.697,461.8687
              L47.022,452.896451 L48.42,452.898469 L48.692,459.804003 C48.705,460.153165 48.99,460.426641
               49.333,460.426641 C49.342,460.426641 49.35,460.425632 49.359,460.425632 C49.714,460.411504
                49.99,460.110781 49.975,459.752537 L49.706,452.899479 L51.359,452.901497 L51.367,459.781802
                 C51.368,460.140046 51.655,460.429669 52.009,460.429669 L52.01,460.429669 C52.365,460.42866
                  52.652,460.138028 52.652,459.779784 L52.643,452.903515 L54.297,452.905533 L54.043,459.76061
                   C54.03,460.117845 54.307,460.418568 54.662,460.431687 C54.67,460.432696 54.678,460.432696
                    54.686,460.432696 C55.029,460.432696 55.314,460.157201 55.327,459.809049 L55.582,452.906543
                     L56.98,452.908561 L56.328,461.8798 Z M52.048,447.296743 C53.066,447.296743 53.93,447.975893
                      54.218,448.908337 L49.879,448.908337 C50.167,447.975893 51.031,447.296743 52.048,447.296743
                       L52.048,447.296743 Z M60,452.104278 C60,450.342322 58.579,448.908337 56.832,448.908337
                        L55.54,448.908337 C55.224,447.25335 53.779,446 52.048,446 C50.318,446 48.873,447.25335
                         48.557,448.908337 L47.168,448.908337 C45.421,448.908337 44,450.342322 44,452.104278
                          L44,452.895442 L45.734,452.895442 L46.416,461.968605 C46.506,463.101867 47.556,463.990918
                           48.808,463.991927 L55.219,464 L55.222,464 C56.474,464 57.522,463.111958 57.609,461.975669
                            L58.269,452.895442 L60,452.895442 L60,452.104278 Z"
          id="Trash"
        />
      </g>
    </g>
  ),
  viewBox: '0 0 16 18'
};
